import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Job } from '../../class/job.class';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAllJobs, selectJobsCount } from '../../store/jobs/jobs.selects';
import { AsyncPipe, NgClass } from '@angular/common';
import { JobRowComponent } from '../../components/job-row/job-row.component';
import { LucideAngularModule } from 'lucide-angular';
import { ResponsiveService } from '../../services/reponsive.service';
import { SortType } from '../../types/sort.type';
import { JobsActions } from '../../store/jobs/jobs.actions';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/boutons/button/button.component';

@Component({
    selector: 'app-my-jobs',
    imports: [RouterLink, TranslateModule , ButtonComponent, LucideAngularModule, NgClass, AsyncPipe, JobRowComponent],
    templateUrl: './my-jobs.component.html',
    styleUrl: './my-jobs.component.scss'
})
export class MyJobsComponent {
  jobs$: Observable<readonly Job[]> = new Observable<readonly Job[]>();
  jobsCount$: Observable<number> = new Observable<number>();
  selectedSortType:SortType = 'created_at'
  
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  constructor(
    public store: Store,
    private router:Router,
    private responsiveService:ResponsiveService,
  ) { }

  sortBy(type:SortType):void{
    this.store.dispatch(JobsActions.sortJobs({sortType:type}));
    this.selectedSortType = type;
  }
  
  ngOnInit(): void {
    this.jobs$ = this.store.select(selectAllJobs);
    this.store.dispatch(JobsActions.sortJobs({sortType:this.selectedSortType}))
    this.jobsCount$ = this.store.select(selectJobsCount)
  }

  navigateToJob(jobId:number):void{
    this.router.navigate(['/dashboard/job/'+jobId])
  }

}
